import { Deserializer } from 'jsonapi-serializer';

const deserializer = (resJson: string) => {
  return new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(resJson);
};

export default deserializer;
